import BlogList from '../routes/BlogList.svelte';
import BlogPost from '../routes/BlogPost.svelte';
import App from '../App.svelte';

export const routes = {
  '/': App,
  '/blog': BlogList,
  '/blog/welcome-to-enkei64-portfolio': BlogPost,
  '/blog/using-nugget-mobilegestalt-tweaks': BlogPost
}; 